import defaultFields from 'store/Host/contextFields';
import { updatePreferences } from 'store/Preferences/actions';
import { selectFields } from './selectors';
import { cloneDeep } from 'lodash';

export function setFieldVisibility (field, value) {
  return async (dispatch, getState) => {
    let host_table = cloneDeep(selectFields(getState()));

    if (!host_table) host_table = { ...defaultFields };
    if (!host_table[field].locked) {
      host_table[field].visible = value;

      if (value) host_table[field].order = Object.keys(host_table).filter((key) => host_table[key].visible).length;
      else {
        let cont = 1;
        Object.keys(host_table)
          .filter(f => host_table[f].visible && f !== field)
          .sort((a, b) => (host_table[a].order - host_table[b].order))
          .forEach(f2 => {
            host_table[f2].order = cont;
            cont++;
          });
      }

      dispatch(updatePreferences({ host_table }));
    }
  };
}

export function setNewOrderColumns (columns) {
  return async (dispatch, getState) => {
    let host_table = cloneDeep(selectFields(getState()));

    if (!host_table) host_table = { ...defaultFields };

    const fixedColumnsCount = Object.values(host_table).filter(col => col.locked).length;

    columns.forEach((column, index) => {
      if (column && !host_table[column].locked) {
        host_table[column].order = index + 1 + fixedColumnsCount;
      }
    });

    dispatch(updatePreferences({ host_table }));
  };
}

export function resetDefault () {
  return async (dispatch) => {
    dispatch(updatePreferences({ host_table: defaultFields }));
  };
}
